import type { TranslationKey } from './i18n';

type Translate = (key: TranslationKey, vars?: Record<string, string | number>) => string;

/**
 * What to say when the API refuses a change: in the reader's language when the
 * work would go to someone outside their departments (OUTSIDE_YOUR_DEPARTMENTS —
 * everyone but the administrators works within their own departments since
 * 2026-10-07) or onto a project that takes no new work (PROJECT_CLOSED — a
 * completed, cancelled or archived one, since 2026-10-09; a finished one with
 * no contract covering today, since 2026-10-27 — `supportStarts` when one
 * starts later), the API's own words otherwise.
 */
export function refusalText(error: unknown, t: Translate): string {
  const e = error as {
    code?: string;
    message?: string;
    details?: { reason?: string; departmentIds?: string[]; supportStarts?: string | null };
  } | null;
  // A whole department beyond one's own, given a task (2026-10-10) — or a person beyond them.
  if (e?.code === 'OUTSIDE_YOUR_DEPARTMENTS') return t(e.details?.departmentIds ? 'reach.outsideDepartment' : 'reach.outside');
  if (e?.code === 'PROJECT_CLOSED') {
    const reason = e.details?.reason;
    if (reason === 'COMPLETED' && e.details?.supportStarts) return t('projects.closedUntil', { date: e.details.supportStarts });
    return t(reason === 'ARCHIVED' ? 'projects.closedArchived' : reason === 'CANCELLED' ? 'projects.closedCancelled' : 'projects.closed');
  }
  return e?.message ?? '';
}
